import { Link } from "react-router-dom";
import { Box, CardMedia, CardContent, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { demoChannelTitle, demoProfilePicture } from "../utils/constants.js";
const MuiChannelCard = ({ channelDetails, marginTop }) => {
  return (
    <Box
      sx={{
        boxShadow: "none",
        borderRadius: "25px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: { xs: "360px", md: "320px" },
        height: "326px",
        margin: "auto",
        marginTop,
      }}
    >
      <Link to={`/channel/${channelDetails?.id?.channelId}`}>
        <CardContent
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            textAlign: "center",
            color: "#fff",
          }}
        >
          <CardMedia
            image={
              channelDetails?.snippet?.thumbnails?.high?.url ||
              demoProfilePicture
            }
            alt={channelDetails?.snippet?.channelTitle}
            sx={{
              borderRadius: "50%",
              height: "180px",
              width: "180px",
              mb: 2,
              border: "1px solid #e3e3e3",
            }}
          />
          <Typography variant="h6">
            {channelDetails?.snippet?.channelTitle ||
              channelDetails?.snippet?.title ||
              demoChannelTitle}
            <CheckCircleIcon
              sx={{ fontSize: "20px", color: "gray", ml: "5px" }}
            />
          </Typography>
          {channelDetails?.statistics?.subscriberCount && (
            <Typography>
              {parseInt(
                channelDetails?.statistics?.subscriberCount
              ).toLocaleString()}{" "}
              Subscriber
            </Typography>
          )}
        </CardContent>
      </Link>
    </Box>
  );
};

export default MuiChannelCard;
